// Price type a label carries when no other one is stated.
export const REGULAR_PRICE_TYPE = 'regular';

export function getRegularPriceValue(position, priceKey) {
	const priceEntries = Array.isArray(position?.prices) ? position.prices : [];
	const regularPriceEntry = priceEntries.find(
		priceEntry => priceEntry.price_type === REGULAR_PRICE_TYPE,
	);
	return regularPriceEntry ? regularPriceEntry[priceKey] : position?.[priceKey];
}

export function getWallExcelPriceCell(position, priceKey) {
	const priceEntries = Array.isArray(position?.prices) ? position.prices : [];
	if (!priceEntries.length) {
		return position?.[priceKey];
	}
	const cellValues = [
		getRegularPriceValue(position, priceKey),
		...priceEntries
			.filter(priceEntry => priceEntry.price_type !== REGULAR_PRICE_TYPE)
			.map(priceEntry => priceEntry[priceKey]),
	].filter(value => value !== null && value !== undefined && value !== '');

	// A single value stays a number so the sheet can still sort and sum it.
	return cellValues.length > 1 ? cellValues.join(', ') : cellValues[0];
}
